// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2L_5w","bigColWidth":"Table_bigColWidth__3SlbJ","biggerColWidth":"Table_biggerColWidth__31DFT","row":"Table_row__3lpxk","col":"Table_col__1np3z"};